import { createSlice } from '@reduxjs/toolkit';
import { extractPathAndQuery } from '../utils/url';
import {
  appError,
  changeLocation,
  setLoadingApp,
  dismissAppAndOverlayError,
} from '../actions';
import type { ErrorActionPayload } from '../actions';
import { getAppName } from './utils';

export interface CurrentAppState {
  name: string | null;
  pathAndQuery: string;
  isLoading: boolean;
  error: ErrorActionPayload | null;
}

const initialState: CurrentAppState = {
  name: null,
  pathAndQuery: '',
  isLoading: false,
  error: null,
};

const currentAppSlice = createSlice({
  name: 'currentApp',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changeLocation, (state, action) => {
        const pathAndQuery = extractPathAndQuery(action.payload.url) ?? '';
        state.name = getAppName(pathAndQuery) ?? null;
        state.pathAndQuery = pathAndQuery;
      })
      .addCase(setLoadingApp, (state, action) => {
        state.isLoading = action.payload;
      })
      .addCase(appError, (state, action) => {
        state.error = action.payload;
      })
      .addCase(dismissAppAndOverlayError, (state) => {
        state.error = null;
      });
  },
});

export const currentAppReducer = currentAppSlice.reducer;
